import { createSlice } from "@reduxjs/toolkit";

const occupationSlice = createSlice({
  name: "occupation",
  initialState: [],
  reducers: {
    occupationAdded(state, action) {
      return action.payload;
    },
  },
});

export const { occupationAdded } = occupationSlice.actions;
export default occupationSlice.reducer;
